import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2, Shield, Briefcase } from 'lucide-react';
export function PackComparison() {
  const porterasComparison = [{
    title: 'Portera sin trabajo específico',
    sin: 'No sabés qué trabajar con ella en cada sesión',
    con: 'Sesiones listas organizadas por objetivo técnico y físico'
  }, {
    title: 'Arquera con miedo a salir',
    sin: 'No tenés ejercicios específicos para trabajar ese aspecto',
    con: 'Protocolo de ejercicios de decisión y salidas progresivas'
  }, {
    title: 'Plantel sin entrenador de porteras',
    sin: 'Tu arquera queda librada a la suerte',
    con: 'Sistema completo para trabajarla vos mismo sin ser especialista'
  }, {
    title: 'Portera nueva en el equipo',
    sin: 'No sabés cómo evaluarla ni cómo nivelarla',
    con: 'Test de evaluación y progresión de porteras incluido'
  }];
  const academiaComparison = [{
    sin: 'Sin diagramas tácticos propios',
    con: 'Pack de diagramas tácticos editables en PDF'
  }, {
    sin: 'Sin fichas individuales de jugadoras',
    con: 'Fichas de rendimiento y seguimiento individual por jugadora'
  }, {
    sin: 'Sin acuerdos formales con clubes',
    con: 'Modelos de contrato y acuerdo con clubes listos para usar'
  }, {
    sin: 'Sin sistema de juego propio',
    con: 'Guía para crear y documentar tu propio sistema de juego'
  }, {
    sin: 'Sin análisis de partidos estructurado',
    con: 'Modelo de análisis de partido propio y rival'
  }, {
    sin: 'Sin checklist de pretemporada',
    con: 'Checklist completo de pretemporada listo para ejecutar'
  }];
  const porterasModules = ['⚽ Módulo 1 — Técnica de Porteras', '🦵 Módulo 2 — Preparación Física Específica', '🧠 Módulo 3 — Táctica y Toma de Decisiones', '📋 Módulo 4 — Sesiones Listas para Usar', '📊 Módulo 5 — Evaluación y Progresión', '🚨 Módulo 6 — Situaciones de Partido y Emergencia'];
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-219">
      <div className="max-w-5xl mx-auto" data-id="element-220">
        <div className="text-center mb-8 md:mb-16" data-id="element-221">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-black text-navy mb-2 md:mb-4" data-id="element-222">
            ¿QUÉ AGREGA EL PACK COMPLETO?
          </motion.h2>
        </div>

        {/* Megapack Porteras Section */}
        <div className="mb-12 md:mb-20" data-id="element-223">
          <div className="flex items-center gap-3 md:gap-4 mb-6 md:mb-8" data-id="element-224">
            <div className="bg-brandGreen/20 p-3 md:p-4 rounded-2xl" data-id="element-225">
              <Shield className="w-6 h-6 md:w-8 md:h-8 text-brandGreen" data-id="element-226" />
            </div>
            <div data-id="element-227">
              <h3 className="text-2xl md:text-3xl font-black text-navy flex items-center gap-2" data-id="element-228">
                💎 MEGAPACK PORTERAS™
              </h3>
              <p className="text-base md:text-xl text-gray-600 font-medium mt-1" data-id="element-229">
                El gran vacío del fútbol femenino argentino. Nadie entrena bien
                a las arqueras.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 mb-8 md:mb-12" data-id="element-230">
            <div className="bg-red-50 p-5 md:p-8 rounded-3xl border border-red-100" data-id="element-231">
              <h4 className="text-lg md:text-xl font-bold text-red-800 mb-3 md:mb-4 flex items-center gap-2" data-id="element-232">
                <XCircle className="w-5 h-5 md:w-6 md:h-6" data-id="element-233" /> Sin el Pack
                Completo
              </h4>
              <p className="text-sm md:text-base text-red-700 font-medium" data-id="element-234">
                No tenés material específico para tu portera. Improvisás o
                directamente la dejás trabajar sola.
              </p>
            </div>
            <div className="bg-green-50 p-5 md:p-8 rounded-3xl border border-green-200 shadow-sm" data-id="element-235">
              <h4 className="text-lg md:text-xl font-bold text-green-800 mb-3 md:mb-4 flex items-center gap-2" data-id="element-236">
                <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6" data-id="element-237" /> Con el Pack
                Completo
              </h4>
              <p className="text-sm md:text-base text-green-800 font-medium" data-id="element-238">
                2 tomos específicos de entrenamiento de porteras con sesiones
                listas, progresión real y sistema de evaluación.
              </p>
            </div>
          </div>

          <div className="space-y-4 md:space-y-6 mb-8 md:mb-12" data-id="element-239">
            {porterasComparison.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-240">
                <div className="bg-gray-50 px-4 md:px-6 py-2 md:py-3 border-b border-gray-200 font-bold text-navy text-sm md:text-base" data-id="element-241">
                  {item.title}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-gray-200" data-id="element-242">
                  <div className="p-4 md:p-6 flex items-start gap-2 md:gap-3 bg-red-50/30" data-id="element-243">
                    <span className="font-bold text-red-500 mt-0.5 text-sm md:text-base" data-id="element-244">
                      Sin →
                    </span>
                    <span className="text-gray-700 text-sm md:text-base" data-id="element-245">
                      {item.sin}
                    </span>
                  </div>
                  <div className="p-4 md:p-6 flex items-start gap-2 md:gap-3 bg-green-50/30" data-id="element-246">
                    <span className="font-bold text-brandGreen mt-0.5 text-sm md:text-base" data-id="element-247">
                      Con →
                    </span>
                    <span className="text-gray-800 font-medium text-sm md:text-base" data-id="element-248">
                      {item.con}
                    </span>
                  </div>
                </div>
              </motion.div>)}
          </div>

          <div className="bg-navy text-white p-6 md:p-8 rounded-3xl" data-id="element-249">
            <h4 className="text-xl md:text-2xl font-black mb-4 md:mb-6 text-center" data-id="element-250">
              MEGAPACK PORTERAS™ INCLUYE:
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4" data-id="element-251">
              {porterasModules.map((mod, i) => <div key={i} className="bg-white/10 p-3 md:p-4 rounded-xl font-medium border border-white/5 text-sm md:text-base" data-id="element-252">
                  {mod}
                </div>)}
            </div>
          </div>
        </div>

        {/* Academia del Entrenador Section */}
        <div data-id="element-253">
          <div className="flex items-center gap-3 md:gap-4 mb-6 md:mb-8" data-id="element-254">
            <div className="bg-brandGreen/20 p-3 md:p-4 rounded-2xl" data-id="element-255">
              <Briefcase className="w-6 h-6 md:w-8 md:h-8 text-brandGreen" data-id="element-256" />
            </div>
            <div data-id="element-257">
              <h3 className="text-2xl md:text-3xl font-black text-navy flex items-center gap-2" data-id="element-258">
                💎 ACADEMIA DEL ENTRENADOR™
              </h3>
              <p className="text-base md:text-xl text-gray-600 font-medium mt-1" data-id="element-259">
                Templates, recursos y herramientas profesionales para gestionar
                tu equipo como un club de primera.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 mb-8 md:mb-12" data-id="element-260">
            <div className="bg-red-50 p-5 md:p-8 rounded-3xl border border-red-100" data-id="element-261">
              <h4 className="text-lg md:text-xl font-bold text-red-800 mb-3 md:mb-4 flex items-center gap-2" data-id="element-262">
                <XCircle className="w-5 h-5 md:w-6 md:h-6" data-id="element-263" /> Sin el Pack
                Completo
              </h4>
              <p className="text-sm md:text-base text-red-700 font-medium" data-id="element-264">
                Trabajás con papeles sueltos, anotaciones en el celular y sin un
                sistema profesional visible.
              </p>
            </div>
            <div className="bg-green-50 p-5 md:p-8 rounded-3xl border border-green-200 shadow-sm" data-id="element-265">
              <h4 className="text-lg md:text-xl font-bold text-green-800 mb-3 md:mb-4 flex items-center gap-2" data-id="element-266">
                <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6" data-id="element-267" /> Con el Pack
                Completo
              </h4>
              <p className="text-sm md:text-base text-green-800 font-medium" data-id="element-268">
                Herramientas profesionales listas para usar que elevan tu imagen
                y tu gestión al siguiente nivel.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-3xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-269">
            {academiaComparison.map((item, index) => <div key={index} className={`grid grid-cols-1 md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-gray-200 ${index !== academiaComparison.length - 1 ? 'border-b border-gray-200' : ''}`} data-id="element-270">
                <div className="p-4 md:p-6 flex items-start gap-2 md:gap-3 bg-red-50/30" data-id="element-271">
                  <span className="font-bold text-red-500 mt-0.5 text-sm md:text-base" data-id="element-272">
                    Sin →
                  </span>
                  <span className="text-gray-700 text-sm md:text-base" data-id="element-273">
                    {item.sin}
                  </span>
                </div>
                <div className="p-4 md:p-6 flex items-start gap-2 md:gap-3 bg-green-50/30" data-id="element-274">
                  <span className="font-bold text-brandGreen mt-0.5 text-sm md:text-base" data-id="element-275">
                    Con →
                  </span>
                  <span className="text-gray-800 font-medium text-sm md:text-base" data-id="element-276">
                    {item.con}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}